import { render, staticRenderFns } from "./addFullReduction.vue?vue&type=template&id=180ac481&scoped=true&"
import script from "./addFullReduction.vue?vue&type=script&lang=js&"
export * from "./addFullReduction.vue?vue&type=script&lang=js&"
import style0 from "./addFullReduction.vue?vue&type=style&index=0&id=180ac481&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "180ac481",
  null
  
)

component.options.__file = "addFullReduction.vue"
export default component.exports